<template>
  <Modal ref="modalRef">
    <template #body>
      <View direction="column" gap="md" padding-block="md" class="dialog">
        <Text variant="h2" align="center">Add your highlights</Text>
        <Text variant="body-large" color="secondary" align="center">
          If you want us to mention something specific in the description
        </Text>
        <Textarea
          class="textarea"
          placeholder="Type your highlights here"
          rows="4"
          v-model="form.fields.highlights"
          :error="form.fieldErrors('highlights')"
        />
      </View>
    </template>
    <template #footer>
      <Button variant="ghost" @click="closeModal">Cancel</Button>
      <Button @click="save" :loading="isSaving">Add & regenerate</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import { Textarea, Button, Modal, useForm, View, Text } from '@tallo/design-system';

import { usePropertyStore } from '../../../stores/property.store';

const emit = defineEmits(['highlightsUpdated']);

const propertyStore = usePropertyStore();
const isSaving = ref(false);
const modalRef = ref<InstanceType<typeof Modal>>();
const form = useForm<{ highlights: string }>({
  highlights: '',
});

async function save() {
  if (form.fields.highlights === propertyStore.property?.highlights) {
    return closeModal();
  }

  isSaving.value = true;

  form.submit(async () => {
    await propertyStore.saveHighlights(form.fields.highlights);

    isSaving.value = false;
    emit('highlightsUpdated');
    closeModal();
  });
}

function closeModal() {
  modalRef.value?.close();
}

function populateHighlights(highlights: string | undefined) {
  form.fields.highlights = highlights || '';
}

watch(() => propertyStore.property?.highlights, populateHighlights, { immediate: true });

defineExpose({ modalRef });
</script>

<style scoped lang="scss">
.dialog {
  max-width: 29rem;
}

.textarea {
  width: 100%;
}
</style>
